var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.276 13.902c-.148-.07-.837-.411-.968-.454-.13-.044-.226-.07-.316.069-.14.19-.292.373-.452.548-.078.092-.159.104-.29.034a3.958 3.958 0 0 1-1.132-.692 4.402 4.402 0 0 1-.788-.97c-.079-.143 0-.218.066-.29a6.955 6.955 0 0 0 .261-.31c.035-.056.055-.102.09-.166a.26.26 0 0 0 0-.246c-.038-.07-.322-.762-.438-1.043-.116-.281-.234-.229-.321-.229s-.174-.017-.27-.017a.536.536 0 0 0-.376.176 1.588 1.588 0 0 0-.49 1.16c0 .16.024.32.07.475.11.351.282.68.506.973.07.096.977 1.553 2.411 2.115 1.434.562 1.432.374 1.692.35.261-.022.838-.335.95-.665a1.16 1.16 0 0 0 .088-.667.826.826 0 0 0-.27-.162l-.023.011Zm3.115-1.298A5.76 5.76 0 0 0 6.882 12.5v.25a5.638 5.638 0 0 0 .817 2.952l-1.037 3.062 3.187-1.014a5.76 5.76 0 0 0 8.536-5v-.146h.006Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 24.995a12.094 12.094 0 1 1 3.725-23.606.406.406 0 0 1 .184.651.403.403 0 0 1-.433.122c-.396-.128-.8-.233-1.208-.315a11.274 11.274 0 1 0 7.678 5.742.406.406 0 1 1 .719-.382A12.1 12.1 0 0 1 12.52 24.995h.01Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.738 4.97a.403.403 0 0 1-.29-.116c-.29-.285-.594-.554-.913-.806-.243-.194-.498-.38-.756-.55a.409.409 0 0 1 .452-.678c.29.185.548.382.811.58.341.271.667.561.977.869a.406.406 0 0 1-.29.695l.009.006Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7b4c1c64d50e67b8c218acd73095c667.svg";
export { ForwardRef as ReactComponent };